import { ApplicationData } from '@tymbe/schema/application.interface';
import moment from 'moment';

import { SuccessAlert } from '../../../components/alerts';
import CancelInvitationButton from '../../../components/buttons/CancelInvitationButton';

const renderCancelInvitationButton = (applicationId: number, refetchData: () => void) => (
  <CancelInvitationButton
    applicationId={applicationId}
    onSuccess={() => {
      SuccessAlert('Pozvánka zrušena');
      refetchData();
    }}
  />
);

type RenderApplicationStateProps = {
  application: ApplicationData,
  refetchData: () => void,
};

const renderApplicationStateButton = ({
  application,
  refetchData,
}: RenderApplicationStateProps) => {
  const { invitation } = application;

  if (invitation && (application?.state === null && !(application?.state === null && application.deleted_at && moment().isAfter(application.deleted_at)))) {
    return renderCancelInvitationButton(application.id, refetchData);
  }

  return null;
};
export default renderApplicationStateButton;
